import { render, staticRenderFns } from "./CatalogCreateView.vue?vue&type=template&id=d4a61c3a&"
import script from "./CatalogCreateView.vue?vue&type=script&lang=js&"
export * from "./CatalogCreateView.vue?vue&type=script&lang=js&"
import style0 from "./CatalogCreateView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports